import React from "react";
import { toast } from "sonner";
import { api, formatErr } from "../../lib/api";
import { KIND } from "../../lib/autoreg";

export const ProposalBox = ({ a, reload }) => {
  const p = a.proposal;
  const decide = (accept) => api.post(`/admin/autoreg/sessions/${a.session_id}/proposal`, { accept })
    .then(() => { toast.success(accept ? "Recálculo aceptado" : "Mantienes tu edición"); reload(); }).catch((e) => toast.error(formatErr(e)));
  return (
    <div style={{ marginTop: 8, padding: 10, border: "1px solid rgba(248,113,113,0.4)", background: "rgba(248,113,113,0.06)" }} data-testid={`ar-proposal-${a.session_id}`}>
      <div style={{ fontWeight: 700 }}>Nuevo cuestionario ({p.checkin_date}): el sistema propone otro ajuste. Tu edición sigue aplicada hasta que decidas.</div>
      <div style={{ color: "#d4d4d4", marginTop: 4 }}>{KIND[p.kind] || p.kind}: {p.changes.length ? p.changes.map((c) => `${c.name} ${c.label} ${c.before || "—"} → ${c.after}`).join(" · ") : "volver a la sesión base"}</div>
      {p.reason && <div style={{ color: "#a3a3a3", fontSize: 12 }}>Motivo: {p.reason}</div>}
      <div style={{ display: "flex", gap: 6, marginTop: 8 }}>
        <button className="qv-btn-primary" style={{ padding: "5px 10px", fontSize: 12 }} onClick={() => decide(true)} data-testid={`ar-proposal-accept-${a.session_id}`}>Aceptar recálculo</button>
        <button className="qv-btn-ghost" style={{ padding: "5px 10px", fontSize: 12 }} onClick={() => decide(false)} data-testid={`ar-proposal-reject-${a.session_id}`}>Mantener mi edición</button>
      </div>
    </div>
  );
};
